import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ApiError } from "../Models/ApiError";
import { ErrorResponseModel } from "../Models/ErrorResponseModel";

export const HandleError = (error: any): ApiError => {
  //check if error is an Axios error
  let resultErr: ApiError = {};

  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;

    if (axiosError?.response?.data) {
      const data = axiosError.response.data as ErrorResponseModel;
      resultErr = {
        ...resultErr,
        message: data.message,
        status: data.status,
        code: axiosError?.code,
      };
    } else {
      resultErr = {
        message: axiosError.message,
        status: axiosError?.response?.status,
        code: axiosError?.code,
      };
    }
  } else {
    resultErr = {
      message: error.message,
      status: error?.response?.status,
      code: error?.code,
    };
  }

  if (error?.response) {
    var err = error.response;
    if (Array.isArray(err?.data.errors)) {
      for (let val of err?.data.errors) {
        if (val.description) {
          toast.warning(val.description);
        }
      }
    } else if (typeof err?.data.errors === "object") {
      for (let e in err?.data.errors) {
        toast.warning(err.data.errors[e][0]);
      }
    } else if (err?.data) {
      toast.warning(err.data);
    } else if (err?.status === 401) {
      toast.dismiss();
    } else if (err?.status === 403) {
      //wrong username or password
    } else if (err) {
      console.log(err);
      if (err?.data) {
        toast.warning(err?.data);
      }
    }
  } else if (error?.code?.toUpperCase() === "ERR_NETWORK") {
    toast.dismiss();
    toast.error("Network Error!");
  }
  return resultErr;
};
